import React from 'react';
import styled from "styled-components";
import {Icon} from "react-materialize";
import propTypes from 'prop-types';

const StyledPagination = styled.div`
  color: black;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 8rem;
  
  .page-count {
    padding-left: 1rem;
    display: flex;
    align-items: center;
    
    button {
      background-color: transparent;
    }
    
    i {
      cursor: pointer;
      border: none;
      &:hover {
        color: #0f82c5;
      }
    }
    
    p {
      padding-left: 4px;
      padding-right: 4px;
      color: #4f4f4f;
    }
  }
  
  .list-count {
    color: #626262;
    padding-right: 6px;
  }
`

const Pagination = ({page = 1, pages=1, count={start: 0, end: 0}, total=0, label='', perPage=10, handleClick}) => {
  //TODO: Need to add in arrow icons for the navigation
  //TODO: possibly turn this into a hook
  const prevPage = () => {
    handleClick('PREVIOUS')
  }

  const nextPage = () => {
    handleClick('NEXT');
  }

  return (
    <StyledPagination>
      <div className={'list-count'}>Showing {count.start} to {count.end} of {total} {label}</div>
      <div className={'page-count'}>
        <button disabled={page === 1} onClick={prevPage}><Icon className={'waves-effect'}>chevron_left</Icon></button>
        <p>{page} of {pages}</p>
        <button disabled={page === pages} onClick={nextPage}><Icon className={'waves-effect'}>chevron_right</Icon></button>
      </div>
    </StyledPagination>
  )
}

Pagination.propTypes = {
    page: propTypes.number,
    pages: propTypes.number,
    count: propTypes.object,
    total: propTypes.number,
    label: propTypes.string,
    perPage: propTypes.string,
    handleClick: propTypes.func
}

export default Pagination;